module.exports = __webpack_public_path__ + "img/logo-light.204f1db9.png";